import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: {
    value: string;
    label: string;
  }[];
  error?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  ...props
}: SelectProps) {
  return <div className={`w-full ${className}`} data-id="element-209">
      {label && <label className="block text-sm font-medium text-text-secondary mb-1.5" data-id="element-210">
          {label}
        </label>}
      <select className={`
          block w-full rounded-lg border border-slate-700 bg-slate-800/50 
          text-text-primary
          focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none
          py-2.5 px-3
          appearance-none
          ${error ? 'border-red-500' : ''}
        `} {...props} data-id="element-211">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-212">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-213">{error}</p>}
    </div>;
}